import React from "react";
import type { ActivityChange } from "../activity-types";
import { StageChangeChunk } from "./stage-change-chunk";
import { DefaultChangeChunk } from "./default-change-chunk";
import { CreationChunk } from "./creation-chunk";
import { DateChunk } from "./date-chunk";
import { AddressChunk } from "./address-chunk";
import { AssigneeChunk } from "./assignee-chunk";
import { AgeChangeChunk } from "./age-change-chunk";
import { CustomFieldChunk } from "./custom-field-chunk";
import { NoteChunk } from "./note-chunk";
import { NoteReplyChunk } from "./note-reply-chunk";
import { TypeChangeChunk } from "./type-change-chunk";
import { NameChangeChunk } from "./name-change-chunk";

interface ActionChunkProps {
  change: ActivityChange;
}

const changeTypeComponents: Record<
  string,
  React.ComponentType<{ change: ActivityChange }>
> = {
  name: NameChangeChunk,
  stageId: StageChangeChunk,
  task: CreationChunk as any,
  startDate: DateChunk,
  targetDate: DateChunk,
  age: AgeChangeChunk,
  address: AddressChunk,
  assignees: AssigneeChunk,
  values: CustomFieldChunk,
  note: NoteChunk,
  noteReply: NoteReplyChunk,
  issueTypeId: TypeChangeChunk,
};

export function ActionChunk({ change }: ActionChunkProps) {
  const Component =
    changeTypeComponents[change.target.type] || DefaultChangeChunk;
  return <Component change={change} />;
}
